// extracted by mini-css-extract-plugin
export default {"fallback-style":"ProjectContainer_fallback-style__UM1Aa"};